import React, { useState } from 'react';
import Menu from '../../components/menu/menu';
import Content from '../../components/content/content';
import ApiService from '../../components/api_services/apiService.jsx';
import './Radii.css';

function Radii() {
  const [form, setForm] = useState({
    r1: '',
    r2: '',
    nominalHeightWys: '',
    actualHeightWys: '',
    lensCf: true,
    actualWidthSzer: '',
    nominalWidthWSzer: '',
    skosyBevelHeight: '0',
  });
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
    setError(null);
    setResult(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setResult(null);

    const r1 = Number(form.r1);
    const r2 = Number(form.r2);
    const nominalHeightWys = Number(form.nominalHeightWys);
    const actualHeightWys = Number(form.actualHeightWys);
    const actualWidthSzer = Number(form.actualWidthSzer);
    const nominalWidthWSzer = Number(form.nominalWidthWSzer);
    const skosyBevelHeight = form.skosyBevelHeight ? Number(form.skosyBevelHeight) : 0;

    const required = [r1, r2, nominalHeightWys, actualHeightWys, actualWidthSzer, nominalWidthWSzer];
    if (required.some((n) => Number.isNaN(n) || n < 0) || (skosyBevelHeight !== 0 && (Number.isNaN(skosyBevelHeight) || skosyBevelHeight < 0))) {
      setError('Wprowadź poprawne nieujemne wartości dla wszystkich pól.');
      return;
    }

    setLoading(true);
    try {
      const data = await ApiService.ringRadii({
        r1,
        r2,
        nominalHeightWys,
        actualHeightWys,
        lensCf: form.lensCf,
        actualWidthSzer,
        nominalWidthWSzer,
        skosyBevelHeight,
      });
      if (data.error) {
        setError(data.error);
        setResult(null);
      } else {
        setResult(data);
        setError(null);
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Błąd połączenia. Sprawdź połączenie i spróbuj ponownie.');
      setResult(null);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Menu />
      <Content>
        <div className="radii-page">
          <h1>Promienie profilu pierścienia (R1, R2)</h1>
          <p className="radii-description">
            Oblicz promienie R1 i R2 dla profilu z zaokrąglonymi krawędziami (soczewka). Wymiary w mm.
          </p>

          <form className="radii-form" onSubmit={handleSubmit}>
            <div className="radii-grid">
              <div className="form-group">
                <label htmlFor="r1">Promień nominalny R1 (górna krawędź) mm</label>
                <input
                  id="r1"
                  name="r1"
                  type="number"
                  step="any"
                  min="0"
                  placeholder="np. 3,5"
                  value={form.r1}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="r2">Promień nominalny R2 (dolna krawędź) mm</label>
                <input
                  id="r2"
                  name="r2"
                  type="number"
                  step="any"
                  min="0"
                  placeholder="np. 3"
                  value={form.r2}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="nominalHeightWys">Wysokość nominalna (wys) mm</label>
                <input
                  id="nominalHeightWys"
                  name="nominalHeightWys"
                  type="number"
                  step="any"
                  min="0"
                  placeholder="np. 1,3"
                  value={form.nominalHeightWys}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="actualHeightWys">Wysokość rzeczywista (wys) mm</label>
                <input
                  id="actualHeightWys"
                  name="actualHeightWys"
                  type="number"
                  step="any"
                  min="0"
                  placeholder="np. 1,3"
                  value={form.actualHeightWys}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="actualWidthSzer">Szerokość rzeczywista (szer) mm</label>
                <input
                  id="actualWidthSzer"
                  name="actualWidthSzer"
                  type="number"
                  step="any"
                  min="0"
                  placeholder="np. 3"
                  value={form.actualWidthSzer}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="nominalWidthWSzer">Szerokość nominalna (szer) mm</label>
                <input
                  id="nominalWidthWSzer"
                  name="nominalWidthWSzer"
                  type="number"
                  step="any"
                  min="0"
                  placeholder="np. 3"
                  value={form.nominalWidthWSzer}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="skosyBevelHeight">Wysokość skosu mm (0 jeśli brak)</label>
                <input
                  id="skosyBevelHeight"
                  name="skosyBevelHeight"
                  type="number"
                  step="any"
                  min="0"
                  placeholder="0"
                  value={form.skosyBevelHeight}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group form-group-checkbox">
                <label className="checkbox-label">
                  <input
                    name="lensCf"
                    type="checkbox"
                    checked={form.lensCf}
                    onChange={handleChange}
                  />
                  <span>Soczewka (wypukłe dno)</span>
                </label>
                <span className="form-hint">Zaznacz, jeśli dolna krawędź ma profil soczewki.</span>
              </div>
            </div>

            {error && <p className="radii-error">{error}</p>}

            <button type="submit" className="radii-submit" disabled={loading}>
              {loading ? 'Obliczanie…' : 'Oblicz R1 i R2'}
            </button>
          </form>

          {result && !error && (
            <div className="radii-result">
              <h2>Wynik</h2>
              <dl className="result-list">
                <dt>R1</dt>
                <dd>{Number(result.r1).toFixed(4)} mm</dd>
                <dt>R2</dt>
                <dd>{Number(result.r2).toFixed(4)} mm</dd>
              </dl>
              <p className="radii-result-hint">Te wartości możesz użyć w kalkulatorze objętości.</p>
            </div>
          )}
        </div>
      </Content>
    </>
  );
}

export default Radii;
